import { getUserbyId } from './getUserById';
import { payrollGetSetup } from './getPayrollSetup';
import { getSalaryDetails } from './getSalaryDetails';
export default { getUserbyId, payrollGetSetup, getSalaryDetails };
